import { render, staticRenderFns } from "./Hire.vue?vue&type=template&id=596cf4a9&scoped=true&"
import script from "./Hire.vue?vue&type=script&lang=js&"
export * from "./Hire.vue?vue&type=script&lang=js&"
import style0 from "./Hire.vue?vue&type=style&index=0&id=596cf4a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596cf4a9",
  null
  
)

export default component.exports